export const Prerequisites = [
    {
        html: <div style={{padding: "5px 10px"}}><span className="creator">Creator</span> wants to create Zips</div>,
        time: ''
    },
    {
        html: <div style={{padding: "5px 10px"}}><span className="creator">Creator</span> talks to <span className="admin">Admin</span> about Zip Audience</div>,
        time: 15
    },
    {
        html: <div style={{padding: "5px 10px"}}><span className="admin">Admin</span> creates groups and adds <span className="creator">Creators</span>,<span className="tester"> Testers</span> and Users</div>,
        time: 20
    },
    {
        html: <div style={{padding: "5px 10px"}}>
                <span className="tester">Testers</span> to make sure they have the right application security permissions
                to test the Zips
            </div>,
        time: 10
    }
]

export const WorkflowData = [
    {
        html: <div style={{padding: "5px 10px"}}><span className="creator">Creator</span> creates/modifies Zips</div>,
        time: ''
    }, 
    {
        html: <div style={{padding: "5px 10px"}}><span className="creator">Creator</span> tells <span className="tester">Tester</span> that Zips are ready for testing</div>,
        time:''
    },
    {
        html: <div style={{padding: "5px 10px"}}><span className="admin">Admin</span> changes the Zips status to "Test"</div>,
        time: 5
    },
    {
        html: <div style={{padding: "5px 10px"}}>
            <p><span className="tester">Tester</span> checks the following:</p>
            <ol>
                <li>Plays back the Zip</li>
                <li>Selectors and Triggers</li>
                <li>Consistency</li>
                <li>Content and process</li>
            </ol>
        </div>,
        time: 30
    },
    {
        html: <div style={{padding: "5px 10px"}}><span className="tester">Tester</span> tells <span className="creator">Creator</span> about testing outcome and if additional work is needed </div>,
        time: 10
    },
    {
        html: <div style={{padding: "5px 10px"}}>Based on the outcome of the above, <span className="creator">Creator</span> informs <span className="admin">Admin</span> to move the Zip to Production</div>,
        time: ''
    }
]

export const Migration = [
    {
        html: <div style={{padding: "5px 10px"}}><span className="admin">
            Admin</span> does the Environment(Staging) to Environment(Production) Zip Migration and
            changes the Zip status to "Test" on Production Environment                                
        </div>,
        time: ''
    },
    {
        html: <div style={{padding: "5px 10px"}}>If <span className="creator">Creator</span> has access to production, they will have the opportunity to validate the Zips one final time</div>,
        time: ''
    },
    {
        html: <div style={{padding: "5px 10px"}}><span className="creator">Creator</span> will inform <span className="admin">Admin</span> to change the Zips status to "Live" on Ziplyne Production</div>,
        time: 10
    },
    {
        html: <div style={{padding: "5px 10px"}}>Zips are now LIVE</div>,
        time: ''
    }
]